import React, { useEffect, useState } from 'react';
import { Field } from '@progress/kendo-react-form';
import isNil from 'lodash/isNil';
import {
  FormNumericTextBox,
  FormDatePicker
} from "src/shared/components/formControls";
import { upsertWarehouseCost } from 'src/fetch/warehouse';
import toastr from 'shared/helpers/toastr';
import errorToastr from 'shared/helpers/errorToastr';
import { required } from 'src/shared/validators/validators';
import './style.scss';
import PageForm from '../../../../shared/components/forms/PageForm';
import { TabBar, Tab } from 'shared/layout/Tabs';
import { HistoryButton } from '../../../../shared/components/buttons';
import AuditHomePage from '../../../../audits/components/pages/AuditHomePage/AuditHomePage';
import { getDateStringForRequest } from 'shared/../helpers/date';

const CostForm = ({ initialValues, onClose, onDataUpdated, history }) => {

  const emptyCost = {
    type: 0,
    hourlyCost: 0,
    effectiveDate: getDateStringForRequest(new Date()),
  };

  const [formInitialValue, setFormInitialValue] = useState(initialValues || emptyCost);

  useEffect(() => {
    setFormInitialValue(initialValues);
  }, [initialValues]);

  const convertValuesToSubmit = ({
    type,
    ...others
  }) => ({
    type: typeof type === 'object' ? type?.value : type,
    ...others
  });

  const handleSubmit = async (data) => {
    await upsertWarehouseCost(convertValuesToSubmit(data))
      .then(() => {
        onClose(true);
        toastr('success', 'Cost Saved Successfully.');
        history.push('/warehouse/costs');
      })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'Cost Save Failed!'
        });
      });
  };

  const handleDelete = async () => {
    const entity = {
      ...formInitialValue,
      isDeleted: true
    };

    await upsertWarehouseCost(convertValuesToSubmit(entity), { confirm: true }).then(() => {
      onClose(true);
      toastr('success', 'Cost Deleted Successfully.');
    })
      .catch((error) => {
        errorToastr({
          error,
          messagePrefix: 'Cost Delete Failed'
        });
      });
  };

  return (
    <div className='has-fixed-toolbar warehouse-cost-form'>
      <PageForm
        id='warehouse-cost-form'
        pageName='Warehouse Cost'
        itemName={`Warehouse Cost with Id ${formInitialValue?.id}`}
        onSubmit={handleSubmit}
        onClose={onClose}
        onDelete={handleDelete}
        initialValues={formInitialValue}
        showDeleteButton={formInitialValue && !isNil(formInitialValue.id)}
        key={JSON.stringify(formInitialValue)}
        renderFields={({ valueGetter, errors, onChange }) => (
          <TabBar>
            <Tab key='cost' title='Warehouse Cost'>
              <fieldset>
                <legend>Operator</legend>
                <div className={'fieldset-item'}>
                  <div>
                    <Field id={'operatorHourlyCost'} name={'operatorHourlyCost'} label={'Hourly Cost'} min={0} component={FormNumericTextBox} />
                  </div>
                  <div style={{ marginLeft: '1rem' }}>
                    <Field style={{ marginTop: '21px' }} id={'operatorEffectiveDate'} name={'operatorEffectiveDate'} label={'Effective Date'} component={FormDatePicker} validator={required} />
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <legend style={{ paddingTop: '2rem' }}>Mule</legend>
                <div className={'fieldset-item'}>
                  <div>
                    <Field id={'muleHourlyCost'} name={'muleHourlyCost'} label={'Hourly Cost'} min={0} component={FormNumericTextBox} />
                  </div>
                  <div style={{ marginLeft: '1rem' }}>
                    <Field style={{ marginTop: '21px' }} id={'muleEffectiveDate'} name={'muleEffectiveDate'} label={'Effective Date'} component={FormDatePicker} validator={required} />
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <legend style={{ paddingTop: '2rem' }}>Clerk</legend>
                <div className={'fieldset-item'}>
                  <div>
                    <Field id={'clerkHourlyCost'} name={'clerkHourlyCost'} label={'Hourly Cost'} min={0} component={FormNumericTextBox} />
                  </div>
                  <div style={{ marginLeft: '1rem' }}>
                    <Field style={{ marginTop: '21px' }} id={'clerkEffectiveDate'} name={'clerkEffectiveDate'} label={'Effective Date'} component={FormDatePicker} validator={required} />
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <legend style={{ paddingTop: '2rem' }}>Admin</legend>
                <div className={'fieldset-item'}>
                  <div>
                    <Field id={'adminHourlyCost'} name={'adminHourlyCost'} label={'Hourly Cost'} min={0} component={FormNumericTextBox} />
                  </div>
                  <div style={{ marginLeft: '1rem' }}>
                    <Field style={{ marginTop: '21px' }} id={'adminEffectiveDate'} name={'adminEffectiveDate'} label={'Effective Date'} component={FormDatePicker} validator={required} />
                  </div>
                </div>
              </fieldset>
            </Tab>
            <Tab
              key='history'
              disabled={isNil(valueGetter('id'))}
              title={
                <HistoryButton
                  title='Warehouse Cost History'
                  disabled={isNil(valueGetter('id'))}
                />
              }
            >
              <AuditHomePage type='warehouse-costs' id={valueGetter('id')} />
            </Tab>
          </TabBar>
        )}>
      </PageForm >
    </div>
  );
};

export default CostForm;